import i18n from '../../i18n';

export const filterTypes = {
  vacancy: 'wolne_miejsca',
  firstLesson: 'first_lesson',
  setDate: 'date_and_hour',
} as const;

export const filters = [
  { slug: filterTypes.vacancy, text: i18n.t('mapFilters.wolne_miejsca') as unknown as string, checked: false },
  //  { slug: 'lekcja_pokazowa', text: 'Lekcja pokazowa', checked: true }
  // {
  //   slug: filterTypes.firstLesson,
  //   text: 'Ustalone 1 spotkanie <div style="background-color:rgb(37,144,193); width:16px; height:16px; border-radius:4px;display:inline-block; position:relative; bottom:-2px;"></div>',
  //   checked: false,
  // },
  // {
  //   slug: filterTypes.setDate,
  //   text: 'Ustalony dzień i godzina <div style="background-color:rgb(57, 83, 42); width:16px; height:16px; border-radius:4px;display:inline-block; position:relative; bottom:-2px;"></div>',
  //   checked: false,
  // },
];
